<template>
    <div>
        <div class="a-flex-rfsfs">
            <le-select-remote-search 
                class="projectBox"
                style="padding:0" 
                v-model="myParentCode" 
                :readonly="disabled"
                :options="optionsincomeDistri" 
                :defaultOptions='defaultIncomeList'
                :disableOptions='disableOptions'
                @input="handleChange"
                placeholder="请选择项目(可搜索)" />
            <le-select-remote-search 
                style="padding:0;margin: 0 10px" 
                :multiple="true" 
                v-model="myStationIdList" 
                :options="optionsStatioinIdList" 
                :readonly="disabled"
                placeholder="请选择站点(可搜索)" />
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
        myParentCode: '',
        myStationIdList: [],
        defaultIncomeList: [],
        optionsincomeDistri: {
            url: this.$Config.apiUrl.incomeDistriList,
            method: "post",
            params: {},
            showLoading: false,
            labelKey: "name",
            valueKey: "id",
            searchKey: "name",
            pageSize: 100,
            optionsOhtherLabelKey: 'companyName',
            optionsOhtherLabelTitle: '所属商户：',
        },//项目数据
        optionsStatioinIdList: {
            url: this.$Config.apiUrl.monthStationList,
            method: "post",
            params: {
                incomeDistriId: ''
            },
            showLoading: false,
            labelKey: "name",
            valueKey: "id",
            searchKey: "name",
        },//站点数据
    };
  },

  props: {
    stationIdList: {
      default: () => {
        return [];
      },
    },
    parentCode: {
        default: ''
    },
    parentName: {
        default: ''
    },
    disabled: {
        default: false
    },
    disableOptions: {
        default: () => {
            return []
        }
    }
  },

  watch: {
    'myParentCode': {
        handler(val) { 
            this.optionsStatioinIdList.params.incomeDistriId = val
            this.$emit('update:parentCode', val)
        }
    },
    'myStationIdList': {
        deep: true,
        handler(val) { 
            this.$emit('update:stationIdList', val)
        }
    }
  },

  mounted() {
    this.myParentCode = this.parentCode
    this.myStationIdList = this.stationIdList

    if(this.parentCode && this.parentName) {
        this.defaultIncomeList = [{
            id: this.parentCode,
            name: this.parentName
        }]
    }
  },

  methods: {
    handleChange () {
        this.myStationIdList = []
    }
  },
};
</script>

<style lang="scss" scoped>
    /deep/ .projectBox{
        &>div{
            margin: 0;
        }
    }
</style>